import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f720c46e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-jc-center p-flex-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  height: "50",
  src: "/empty_data.svg"
}, null, -1))
const _hoisted_3 = { class: "p-col-12 p-text-center" }
const _hoisted_4 = { class: "p-d-flex p-ai-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_ctx.invitations.meta.totalItems)
    ? (_openBlock(), _createBlock(_component_Accordion, {
        key: 0,
        "active-index": 0,
        id: "invitations",
        lazy: "",
        class: "p-mt-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AccordionTab, {
            header: `${_ctx.$t('activity.invitations')}(${_ctx.invitations.meta.totalItems})`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DataTable, {
                value: _ctx.invitations.items,
                lazy: "",
                paginator: true,
                class: "p-datatable-sm",
                showGridlines: "",
                "total-records": _ctx.invitations.meta.totalItems,
                dataKey: "id",
                responsiveLayout: "scroll",
                onPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.input.page = $event.page + 1)),
                "rows-per-page-options": [20, 40, 50],
                rows: _ctx.input.limit,
                "onUpdate:rows": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.limit) = $event)),
                loading: _ctx.loading
              }, {
                empty: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("noData")), 1)
                  ])
                ]),
                loading: _withCtx(() => [
                  _createVNode(_component_ProgressSpinner)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "createdAt",
                    sortable: true,
                    "sort-field": "createdAt",
                    header: _ctx.$t('date')
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(_ctx.$d(data.createdAt, "long")), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    field: "role",
                    sortable: true,
                    "sort-field": "role",
                    header: _ctx.$t('activity.as')
                  }, {
                    body: _withCtx(({ data, field }) => [
                      _createTextVNode(_toDisplayString(data[field]?.name), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    sortable: true,
                    "sort-field": "inviter.name",
                    header: _ctx.$t('activity.inviter')
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_Avatar, {
                          image: _ctx.getImage(data.inviter.image, 'users'),
                          class: "p-mr-2",
                          size: "large",
                          shape: "circle"
                        }, null, 8, ["image"]),
                        _createTextVNode(" " + _toDisplayString(data.inviter.name), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    sortable: true,
                    "sort-field": "activity.name",
                    header: _ctx.$t('activity.activity')
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", null, _toDisplayString(data.activity.name), 1),
                      _createElementVNode("small", null, _toDisplayString(data.activity.address), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    header: _ctx.$t('activity.actions')
                  }, {
                    body: _withCtx(({ data }) => [
                      _createVNode(_component_Button, {
                        onClick: ($event: any) => (_ctx.submitAcceptation(data.activity.id)),
                        class: "p-mr-2",
                        label: _ctx.$t('confirm'),
                        disabled: _ctx.acceptLoading,
                        loading: _ctx.acceptLoading
                      }, null, 8, ["onClick", "label", "disabled", "loading"]),
                      _createVNode(_component_Button, {
                        onClick: ($event: any) => (_ctx.submitRemove($event, data.id, false)),
                        class: "p-button-danger",
                        label: _ctx.$t('refuse'),
                        disabled: _ctx.removeLoading,
                        loading: _ctx.removeLoading
                      }, null, 8, ["onClick", "label", "disabled", "loading"])
                    ]),
                    _: 1
                  }, 8, ["header"])
                ]),
                _: 1
              }, 8, ["value", "total-records", "rows", "loading"])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}